import { Popover } from "antd";

export function CleanAndSafeIcon({ iconSize, leftMargin }) {
  const hoverAHPContent = <div>Clean and Safe</div>;

  return (
    <div
      className="ahp-store-stamp"
      style={{
        // left: leftMargin,
        ...iconSize,
      }}
    >
      <Popover
        style={{
          width: 500,
        }}
        content={hoverAHPContent} // title="Hover title"
        trigger="hover" // visible={this.state.hovered}
        // onVisibleChange={this.handleHoverChange}
      >
        <img
          src="https://portugalcleanandsafe.com/assets/badge.png"
          alt="Clean and Safe logo"
          width={iconSize.width * 1}
        />
      </Popover>
    </div>
  );
}
